import t from "./VoiceSearch.vue_rollup-plugin-vue=script.js";
export default (function (t, e, r, n, s, i, a, o) {
  var l = ("function" == typeof r ? r.options : r) || {};
  return l.__file = "VoiceSearch.vue", l.render || (l.render = t.render, l.staticRenderFns = t.staticRenderFns, l._compiled = !0, s && (l.functional = !0)), l._scopeId = n, l;
})({
  render: function render() {
    var t = this,
        e = t.$createElement,
        r = t._self._c || e;
    return t.state ? r("div", {
      class: t.suit()
    }, [t._t("default", function () {
      return [r("button", {
        class: t.suit("button"),
        attrs: {
          type: "button",
          title: t.state.isBrowserSupported ? t.buttonTitle : t.disabledButtonTitle,
          disabled: !t.state.isBrowserSupported
        },
        on: {
          click: t.handleClick
        }
      }, [t._t("buttonText", function () {
        return [t.errorNotAllowed ? r("svg", t._b({}, "svg", t.buttonSvgAttrs, !1), [r("line", {
          attrs: {
            x1: "1",
            y1: "1",
            x2: "23",
            y2: "23"
          }
        }), t._v(" "), r("path", {
          attrs: {
            d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
          }
        }), t._v(" "), r("path", {
          attrs: {
            d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
          }
        }), t._v(" "), r("line", {
          attrs: {
            x1: "12",
            y1: "19",
            x2: "12",
            y2: "23"
          }
        }), t._v(" "), r("line", {
          attrs: {
            x1: "8",
            y1: "23",
            x2: "16",
            y2: "23"
          }
        })]) : r("svg", t._b({}, "svg", t.buttonSvgAttrs, !1), [r("path", {
          attrs: {
            d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z",
            fill: t.state.isListening ? "currentColor" : "none"
          }
        }), t._v(" "), r("path", {
          attrs: {
            d: "M19 10v2a7 7 0 0 1-14 0v-2"
          }
        }), t._v(" "), r("line", {
          attrs: {
            x1: "12",
            y1: "19",
            x2: "12",
            y2: "23"
          }
        }), t._v(" "), r("line", {
          attrs: {
            x1: "8",
            y1: "23",
            x2: "16",
            y2: "23"
          }
        })])];
      }, null, t.innerSlotProps)], 2), t._v(" "), r("div", {
        class: t.suit("status")
      }, [t._t("status", function () {
        return [r("p", [t._v(t._s(t.state.voiceListeningState.transcript))])];
      }, null, t.innerSlotProps)], 2)];
    }, null, t.rootSlotProps)], 2) : t._e();
  },
  staticRenderFns: []
}, 0, t, void 0, !1);